/* French first, English second. Strings live in i18n/<lang>.json, same keys. */
import { computed, signal } from "@preact/signals";
import en from "./i18n/en.json";
import fr from "./i18n/fr.json";

export type Lang = "fr" | "en";
export type LangMode = Lang | "system";

const TABLES: Record<Lang, Record<string, string>> = { fr, en };

export function systemLang(): Lang {
  const l = (typeof navigator !== "undefined" ? navigator.languages?.[0] ?? navigator.language : "fr") ?? "fr";
  return l.toLowerCase().startsWith("en") ? "en" : "fr";
}

/** set by the app from the user's choice or the managed setting */
export const lang = signal<Lang>("fr");
export const locale = computed(() => (lang.value === "fr" ? "fr-CA" : "en-CA"));

export function t(key: string, ...args: (string | number)[]): string {
  const s = TABLES[lang.value][key] ?? TABLES.fr[key] ?? key;
  return args.length ? s.replace(/\{(\d)\}/g, (_, i) => String(args[Number(i)] ?? "")) : s;
}

export function setDocumentLang(l: Lang): void {
  lang.value = l;
  if (typeof document !== "undefined") document.documentElement.lang = l;
}
